import { defineNuxtPlugin } from '#imports'

import { useBrowsingHistoryConsent } from '../scopes/browsing-history/composables/useBrowsingHistoryConsent'

export default defineNuxtPlugin(() => {
  useBrowsingHistoryConsent()
})
